import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'

const RenderOnViewportEntry = ({ children, fallback, observerOptions }) => {
  const { ref, inView } = useInView(observerOptions)

  return (
    <div data-testid="render-on-viewport-entry" ref={ref}>
      {inView && <Suspense fallback={fallback}>{children}</Suspense>}
    </div>
  )
}

RenderOnViewportEntry.defaultProps = {
  fallback: 'Loading...',
  observerOptions: {
    root: null,
    rootMargin: '0px',
    threshold: 0,
    triggerOnce: true,
  },
}
RenderOnViewportEntry.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node,
  observerOptions: PropTypes.object,
}

export default RenderOnViewportEntry
